module.exports = __webpack_public_path__ + "img/家用电器6.77b31a7f.jpg";